import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Eyebrow, Icon } from "@/components/site/ui";
import { Reveal } from "@/components/site/motion";
import { PILLARS } from "@/data/content";

export default function Expertises() {
  return (
    <>
      <PageHero
        eyebrow="Nos expertises"
        titleLines={["Quatre pôles", "complémentaires"]}
        subtitle="Une approche multidisciplinaire pour couvrir l'intégralité de vos enjeux stratégiques en Afrique de l'Ouest."
      />

      {PILLARS.map((p, idx) => {
        const dark = idx % 2 === 1;
        return (
          <section
            key={p.key}
            id={p.key}
            className={`${dark ? "bg-night" : "bg-cream"} py-24 scroll-mt-24`}
            data-testid={`expertise-detail-${p.num}`}
          >
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
              <div className={`grid lg:grid-cols-2 gap-14 items-center ${idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <Reveal>
                  <div className={`relative rounded-3xl border p-10 ${dark ? "border-gold/20 bg-navy/40" : "border-navy/10 bg-white"}`}>
                    <span className={`font-display text-[7rem] leading-none font-bold ${dark ? "text-white/5" : "text-navy/5"} absolute top-4 right-8 select-none`}>{p.num}</span>
                    <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-gold to-gold-light text-navy">
                      <Icon name={p.icon} size={30} />
                    </span>
                    <ul className="mt-8 space-y-3">
                      {p.services.map((s) => (
                        <li key={s} className={`flex items-center gap-3 font-body ${dark ? "text-white/80" : "text-anthracite"}`}>
                          <ArrowRight size={16} className="text-gold shrink-0" /> {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>

                <Reveal delay={0.1}>
                  <Eyebrow light={dark}>Pôle {p.num}</Eyebrow>
                  <h2 className={`mt-4 font-display text-3xl sm:text-4xl font-medium leading-tight ${dark ? "text-white" : "text-navy"}`}>{p.title}</h2>
                  <p className={`mt-5 font-body leading-relaxed ${dark ? "text-white/70" : "text-anthracite"}`}>{p.context}</p>
                  <blockquote className={`mt-6 border-l-2 border-gold pl-5 italic font-body ${dark ? "text-gold-light" : "text-navy"}`}>“{p.quote}”</blockquote>

                  <div className="mt-6 flex flex-wrap gap-6">
                    {p.kpis.map((kpi) => (
                      <div key={kpi.k}>
                        <div className="font-display text-2xl font-semibold text-gold-gradient">{kpi.k}</div>
                        <p className={`text-xs font-body ${dark ? "text-white/60" : "text-anthracite/70"}`}>{kpi.v}</p>
                      </div>
                    ))}
                  </div>

                  <div className="mt-6">
                    <p className={`text-xs uppercase tracking-[0.2em] mb-3 ${dark ? "text-gold-light" : "text-gold"}`}>Livrables clés</p>
                    <div className="flex flex-wrap gap-2">
                      {p.deliverables.map((d) => (
                        <span key={d} className={`rounded-full px-3 py-1.5 text-xs font-body ${dark ? "bg-white/10 text-white/80" : "bg-navy/5 text-navy"}`}>{d}</span>
                      ))}
                    </div>
                  </div>

                  <Link to="/contact" className="mt-7 inline-flex items-center gap-2 font-semibold text-gold hover:gap-3 transition-all">
                    En savoir plus <ArrowRight size={16} />
                  </Link>
                </Reveal>
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
}
